import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

/**
 * Closes the bet receipt when a user logs out
 */
const useCloseReceiptOnLogout = () => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch.betSlip.receiptClosed();
    }
  }, [isAuthenticated, dispatch]);
};

export default useCloseReceiptOnLogout;
